import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { AppInput } from "../../../../shared/components/AppInput";
import { selectSelectedStylist } from "../../redux/selectors";
import styles from "./styles.module.css";

interface Props {
  onStylistNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const StylistNameChangeInput: FC<Props> = ({ onStylistNameChange }) => {
  const selectedStylist = useAppSelector(selectSelectedStylist);
  const { t } = useTranslation();

  return (
    <div className={styles["input-container"]}>
      <div className={styles.label}>{t("stylist.name_input_label")}</div>
      <AppInput
        value={selectedStylist?.friendly_name}
        onChange={onStylistNameChange}
        className={styles.input}
        placeholder={t("stylist.name_input_placeholder")}
      />
    </div>
  );
};
